import React from 'react';

// import styled components
import {
  ReviewItemWrapper,
  ReviewItemContent,
  ReviewItemContentContainer,
  ReviewItemFooter,
  ReviewItemFooterImageWrapper,
  ReviewItemFooterRating,
} from './styled';

const truncateComments = (comment, name) => {
  const maxLength = 350;

  if (comment.length <= maxLength) return <p>{comment}</p>;

  const excerpt = comment.slice(0, maxLength);
  const lastSpaceIndex = excerpt.lastIndexOf(' ');
  const trimmedExcerpt = excerpt.slice(0, lastSpaceIndex);

  return (
    <>
      <p>{`${trimmedExcerpt}...`}</p>
      {/* <a
        // href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Read ${name}'s review`}
      >
        Read full review
      </a> */}
    </>
  );
};

const ReviewItem = ({
  comment,
  date,
  rating,
  name,
  QuoteLeft,
  QuoteRight,
  // url,
}) => {
  return (
    <ReviewItemWrapper>
      <QuoteLeft className="quote-left" />
      <ReviewItemContentContainer>
        <ReviewItemContent>
          {truncateComments(comment, name)}
          <QuoteRight className="quote-right" />
        </ReviewItemContent>
      </ReviewItemContentContainer>
      <ReviewItemFooter>
        <ReviewItemFooterRating>
          <span
            dangerouslySetInnerHTML={{ __html: `${'&#9733;'.repeat(rating)}` }}
          />
          <p>{`${name.charAt(0).toUpperCase()}${name.slice(
            1,
            name.length
          )} ${name.charAt(0).toUpperCase()}.`}</p>
        </ReviewItemFooterRating>
        <ReviewItemFooterImageWrapper>
          {/* <img src={} alt={nickName} /> */}
        </ReviewItemFooterImageWrapper>
      </ReviewItemFooter>
    </ReviewItemWrapper>
  );
};

export default ReviewItem;
